/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Badge_NewInputs */

const en_badge_new = /** @type {(inputs: Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New`)
};

const de_badge_new = /** @type {(inputs: Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu`)
};

/**
* | output |
* | --- |
* | "New" |
*
* @param {Badge_NewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const badge_new = /** @type {((inputs?: Badge_NewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_NewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_badge_new(inputs)
	return en_badge_new(inputs)
});